<div class="denuncia-flow">
  <div class="denuncia-flow__shell">
    <div class="popup-overlay" *ngIf="mostrarPopupAnonimo">
      <div class="popup-box">
        <div class="popup-icon">⚠️</div>
        <h3>Aviso importante</h3>
        <p>
          En caso de presentar la información de forma anónima, le recomendamos que
          en la descripción de los hechos <strong>no incluya datos personales</strong>
          que le puedan identificar. Recuerda que tu denuncia es anónima por lo cual será imposible contactarte
          por lo cual te pedimos ser lo más claro y detallado en los datos que proporcionas acerca del caso.
        </p>
        <button class="btn-primary" (click)="cerrarPopup()">Entendido</button>
      </div>
    </div>

    <ng-container *ngIf="paso === 'modalidad'; else formularioTpl">
      <section class="denuncia-entry">
        <header class="denuncia-entry__header">
          <span class="denuncia-entry__eyebrow">Canal de Denuncias</span>
          <h1>Elija su modalidad de reporte</h1>
          <p>Seleccione la opción que mejor se adapte a su nivel de comodidad.</p>
        </header>

        <div class="denuncia-entry__grid">
          <article class="denuncia-option denuncia-option--anonymous"
            [class.denuncia-option--selected]="modalidadSeleccionada === TipoDenuncia.ANONIMA"
            (click)="seleccionarModalidad(TipoDenuncia.ANONIMA)" (keydown.enter)="$event.target === $event.currentTarget ? seleccionarModalidad(TipoDenuncia.ANONIMA) : null">
            <div class="denuncia-option__icon denuncia-option__icon--anonymous"></div>
            <h2>Anónima</h2>
            <p>
              No se solicitará ningún dato personal. Recibirá un código de seguimiento único
              para consultar el avance de su caso. Es el nivel máximo de privacidad.
            </p>

            <ul class="denuncia-option__list">
              <li>Sin identificación personal</li>
              <li>Seguimiento mediante ID seguro</li>
            </ul>

            <button type="button"
              [ngClass]="modalidadSeleccionada === TipoDenuncia.ANONIMA ? 'btn-primary btn-primary--glow' : 'btn-secundario btn-secundario--soft'"
              (click)="$event.stopPropagation(); iniciarFormulario(TipoDenuncia.ANONIMA)">
              Reportar de forma anónima
            </button>
          </article>

          <article class="denuncia-option denuncia-option--confidential"
            [class.denuncia-option--selected]="modalidadSeleccionada === TipoDenuncia.CONFIDENCIAL"
            (click)="seleccionarModalidad(TipoDenuncia.CONFIDENCIAL)" (keydown.enter)="$event.target === $event.currentTarget ? seleccionarModalidad(TipoDenuncia.CONFIDENCIAL) : null">
            <div class="denuncia-option__icon denuncia-option__icon--confidential"></div>
            <h2>Confidencial</h2>
            <p>
              Incluye sus datos de contacto para que nuestro equipo de cumplimiento pueda
              solicitar aclaraciones. Su identidad será tratada con absoluta reserva.
            </p>

            <ul class="denuncia-option__list">
              <li>Comunicación directa bidireccional</li>
              <li>Protección de identidad garantizada</li>
            </ul>

            <button type="button"
              [ngClass]="modalidadSeleccionada === TipoDenuncia.CONFIDENCIAL ? 'btn-primary btn-primary--glow' : 'btn-secundario btn-secundario--soft'"
              (click)="$event.stopPropagation(); iniciarFormulario(TipoDenuncia.CONFIDENCIAL)">
              Reportar con mis datos
            </button>
          </article>
        </div>
      </section>
    </ng-container>

    <ng-template #formularioTpl>
      <section class="denuncia-form" [class.denuncia-form--anonymous]="tipo === TipoDenuncia.ANONIMA"
        [class.denuncia-form--confidential]="tipo === TipoDenuncia.CONFIDENCIAL">
        <ng-container *ngIf="tipo === TipoDenuncia.ANONIMA; else confidentialFormTpl">
          <div class="anonymous-report">
            <div class="anonymous-report__topbar">
              <button type="button" class="denuncia-form__back" (click)="cambiarModalidad()">
                ← Cambiar modalidad
              </button>
            </div>

            <div class="anonymous-report__progress" aria-hidden="true"></div>

            <header class="anonymous-report__header">
              <h1>Nueva Denuncia Anónima</h1>
              <p>Su identidad está protegida bajo protocolos de encriptación de alta seguridad.</p>
            </header>

            <div class="anonymous-report__stack">
              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaCategoriaAnonima">
                  Categoría del incidente <span class="requerido">*</span>
                </label>
                <div class="anonymous-report__field anonymous-report__field--select">
                  <select id="denunciaCategoriaAnonima" [(ngModel)]="denuncia.id_categoria">
                    <option value="">Seleccione una categoría</option>
                    <option *ngFor="let cat of categorias" [value]="cat.id_categoria">
                      {{ cat.nombre }}
                    </option>
                  </select>
                </div>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaHechosAnonima">
                  Relato de los hechos <span class="requerido">*</span>
                </label>
                <div class="anonymous-report__field anonymous-report__field--textarea">
                  <textarea id="denunciaHechosAnonima" [(ngModel)]="denuncia.hechos" rows="7" maxlength="15000"
                    placeholder="Describa lo sucedido de la forma más detallada posible..."></textarea>
                </div>
                <p class="anonymous-report__limit" *ngIf="(denuncia.hechos?.length || 0) >= 15000">Has alcanzado el límite.</p>
                <p class="anonymous-report__hint">
                  Recuerde no incluir nombres propios o datos que permitan ser asociados a usted.
                </p>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label">Adjuntar evidencia</label>
                <label class="anonymous-report__upload" for="fileInput"
                  (dragover)="onArrastrarArchivo($event)" (drop)="onSoltarArchivo($event)">
                  <span class="anonymous-report__upload-icon" aria-hidden="true"></span>
                  <span class="anonymous-report__upload-title">
                    {{ archivoNombre || 'Clic para subir o arrastrar un archivo' }}
                  </span>
                  <span class="anonymous-report__upload-meta">{{ archivoMeta }}</span>
                </label>
                <input id="fileInput" type="file" [attr.accept]="evidenciaAccept" (change)="onArchivoSeleccionado($event)" style="display:none">
                <p class="anonymous-report__hint anonymous-report__hint--formatos">{{ evidenciaTexto }}</p>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaProteccionAnonima">
                  ¿Se siente seguro realizando esta denuncia? ¿Considera que requiere protección frente a
                  represalias o similares?
                </label>
                <div class="anonymous-report__field anonymous-report__field--textarea">
                  <textarea id="denunciaProteccionAnonima" [(ngModel)]="denuncia.requiereProteccion" rows="5" maxlength="15000"
                    placeholder="Explique su situación de seguridad o si requiere alguna medida de protección específica..."></textarea>
                </div>
                <p class="anonymous-report__limit" *ngIf="(denuncia.requiereProteccion?.length || 0) >= 15000">Has alcanzado el límite.</p>
              </section>

              <div class="terminos-row terminos-row--anonymous">
                <input type="checkbox" id="terminos" [(ngModel)]="aceptaTerminos">
                <label for="terminos">
                  He leído y acepto el compromiso de veracidad de la información presentada y los términos
                  de privacidad. <span class="requerido">*</span>
                </label>
              </div>

              <div class="anonymous-report__captcha">
                <div id="recaptcha-widget-anonimo"></div>
                <div class="anonymous-report__captcha-copy" *ngIf="captchaError">
                  <strong>{{ captchaError }}</strong>
                </div>
              </div>

              <div class="error-mensaje" *ngIf="errorMensaje">
                ⚠️ {{ errorMensaje }}
              </div>

              <div class="acciones acciones--anonymous">
                <button class="btn-link" (click)="cancelar()" [disabled]="cargando">Cancelar denuncia</button>
                <button class="btn-primary btn-primary--glow" (click)="enviar()" [disabled]="cargando">
                  <span *ngIf="!cargando">Enviar denuncia →</span>
                  <span *ngIf="cargando">Enviando...</span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #confidentialFormTpl>
          <div class="anonymous-report anonymous-report--confidential">
            <div class="anonymous-report__topbar">
              <button type="button" class="denuncia-form__back" (click)="cambiarModalidad()">
                ← Cambiar modalidad
              </button>
            </div>

            <div class="anonymous-report__progress" aria-hidden="true"></div>

            <header class="anonymous-report__header">
              <h1>Nueva Denuncia Confidencial</h1>
              <p>
                Sus datos de contacto serán resguardados con absoluta reserva para permitir
                comunicación protegida con el equipo de cumplimiento.
              </p>
            </header>

            <div class="anonymous-report__stack">
              <section class="anonymous-report__card">
                <label class="anonymous-report__label">
                  Datos de contacto <span class="requerido">*</span>
                </label>

                <div class="report-contact-grid">
                  <div class="report-contact-field">
                    <span class="report-contact-field__label">Nombre <span class="requerido">*</span></span>
                    <div class="anonymous-report__field">
                      <input type="text" aria-label="Nombre" [(ngModel)]="denuncia.nombre" placeholder="Tu nombre" maxlength="30">
                    </div>
                  </div>

                  <div class="report-contact-field">
                    <span class="report-contact-field__label">Apellidos <span class="requerido">*</span></span>
                    <div class="anonymous-report__field">
                      <input type="text" aria-label="Apellidos" [(ngModel)]="denuncia.apellidos" placeholder="Tus apellidos" maxlength="30">
                    </div>
                  </div>

                  <div class="report-contact-field">
                    <span class="report-contact-field__label">Teléfono</span>
                    <div class="anonymous-report__field">
                      <input type="tel" aria-label="Teléfono" [(ngModel)]="denuncia.telefono" placeholder="10 dígitos"
                        inputmode="numeric" maxlength="10" (input)="onTelefonoInput($event)">
                    </div>
                  </div>

                  <div class="report-contact-field">
                    <span class="report-contact-field__label">Correo <span class="requerido">*</span></span>
                    <div class="anonymous-report__field">
                      <input type="email" aria-label="Correo" [(ngModel)]="denuncia.email" placeholder="correo@ejemplo.com" maxlength="30">
                    </div>
                  </div>
                </div>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaCategoriaConfidencial">
                  Categoría del incidente <span class="requerido">*</span>
                </label>
                <div class="anonymous-report__field anonymous-report__field--select">
                  <select id="denunciaCategoriaConfidencial" [(ngModel)]="denuncia.id_categoria">
                    <option value="">Seleccione una categoría</option>
                    <option *ngFor="let cat of categorias" [value]="cat.id_categoria">
                      {{ cat.nombre }}
                    </option>
                  </select>
                </div>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaHechosConfidencial">
                  Relato de los hechos <span class="requerido">*</span>
                </label>
                <div class="anonymous-report__field anonymous-report__field--textarea">
                  <textarea id="denunciaHechosConfidencial" [(ngModel)]="denuncia.hechos" rows="7" maxlength="15000"
                    placeholder="Describa lo sucedido de la forma más detallada posible..."></textarea>
                </div>
                <p class="anonymous-report__limit" *ngIf="(denuncia.hechos?.length || 0) >= 15000">Has alcanzado el límite.</p>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label">Adjuntar evidencia</label>
                <label class="anonymous-report__upload" for="fileInputConfidencial"
                  (dragover)="onArrastrarArchivo($event)" (drop)="onSoltarArchivo($event)">
                  <span class="anonymous-report__upload-icon" aria-hidden="true"></span>
                  <span class="anonymous-report__upload-title">
                    {{ archivoNombre || 'Clic para subir o arrastrar un archivo' }}
                  </span>
                  <span class="anonymous-report__upload-meta">{{ archivoMeta }}</span>
                </label>
                <input id="fileInputConfidencial" type="file" [attr.accept]="evidenciaAccept" (change)="onArchivoSeleccionado($event)" style="display:none">
                <p class="anonymous-report__hint anonymous-report__hint--formatos">{{ evidenciaTexto }}</p>
              </section>

              <section class="anonymous-report__card">
                <label class="anonymous-report__label" for="denunciaProteccionConfidencial">
                  ¿Se siente seguro realizando esta denuncia? ¿Considera que requiere protección frente a
                  represalias o similares?
                </label>
                <div class="anonymous-report__field anonymous-report__field--textarea">
                  <textarea id="denunciaProteccionConfidencial" [(ngModel)]="denuncia.requiereProteccion" rows="5" maxlength="15000"
                    placeholder="Explique si requiere resguardo adicional o alguna medida de protección específica..."></textarea>
                </div>
                <p class="anonymous-report__limit" *ngIf="(denuncia.requiereProteccion?.length || 0) >= 15000">Has alcanzado el límite.</p>
              </section>

              <div class="terminos-row terminos-row--anonymous">
                <input type="checkbox" id="terminosConfidencial" [(ngModel)]="aceptaTerminos">
                <label for="terminosConfidencial">
                  Marcando esta casilla acepta el tratamiento confidencial de sus datos para la investigación
                  del reporte y confirma haber leído la <strong>Política de Privacidad</strong>.
                  <span class="requerido">*</span>
                </label>
              </div>

              <div class="anonymous-report__captcha">
                <div id="recaptcha-widget-confidencial"></div>
                <div class="anonymous-report__captcha-copy" *ngIf="captchaError">
                  <strong>{{ captchaError }}</strong>
                </div>
              </div>

              <div class="error-mensaje" *ngIf="errorMensaje">
                ⚠️ {{ errorMensaje }}
              </div>

              <div class="acciones acciones--anonymous">
                <button class="btn-link" (click)="cancelar()" [disabled]="cargando">Cancelar denuncia</button>
                <button class="btn-primary btn-primary--glow" (click)="enviar()" [disabled]="cargando">
                  <span *ngIf="!cargando">Enviar denuncia →</span>
                  <span *ngIf="cargando">Enviando...</span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </section>
    </ng-template>
  </div>
</div>